module.exports = __webpack_public_path__ + "static/img/nose_02.daf4a86.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/noses/thumbnail/nose_02.png
// module id = CXvK
// module chunks = 0